const initialState = []

function updateObjectInArray(array, action) {
    return array.map( (item, index) => {
        if(item.token_id !== action.vehicle.token_id) {
            // This isn't the item we care about - keep it as-is

            // If the updated item has primary set to true, then update other objects in the array
            // This check is specific to vehicles
            if (action.vehicle.primary) {
              return {...item, primary: !action.vehicle.primary}
            }

            return item;
        }

        // Otherwise, this is the one we want - return an updated value
        return {
            ...item,
            ...formatVehicle(action.vehicle)
        };
    });
}

const formatVehicles = (state, action) => {

  const formattedVehicles = action.user.vehicles.map((vehicle, index) => {
    return formatVehicle(vehicle)
  })

  return [...state, ...formattedVehicles]
}

const formatVehicle = (vehicle) => {
  // Return array of odometer readings with most recent year -> oldest year
  var years = Object.keys(vehicle.odometer_readings)
                    .sort((a,b)=>b-a)
                    .map(v => vehicle.odometer_readings[v])

  vehicle.odometer_readings = years
  return vehicle
}

function vehicles(state=initialState, action) {
  switch (action.type) {
    case "VEHICLES_SUCCESS":

      return formatVehicles(state, action)

    case "LOGIN_SUCCESS":
    case "USER_SUCCESS":
      return formatVehicles(state, action)

    case 'LOGOUT_SUCCESS':
      return initialState

    case "CREATE_VEHICLE_SUCCESS":
      const array = [
        ...state,
        {...action.vehicle}
      ]
      // We need to return this function in order to update the attribute 'primary' on all vehicles
      return updateObjectInArray(array, action)

    case "UPDATE_VEHICLE_SUCCESS":
      return updateObjectInArray(state, action)

    case "DELETE_VEHICLE_SUCCESS":

      return [
        ...state.filter( vehicle =>
          vehicle.token_id !== action.token_id
        )
      ]

    default:
      return state
  }
}

export default vehicles



// WEBPACK FOOTER //
// ./src/models/vehicles.js